export default __webpack_public_path__ + "images/baee420ad7494b5e81ebdb475da51c6c.png";